import { IconPrinter, IconSend } from '@tabler/icons-react'
import type { JSX } from 'react'
import { DropdownMenuItem } from '#src/components/core/index.ts'

export function MedicationsPrintFaxMenuItems({
  onPrint,
  onFax,
  onDismiss,
  isPrinting,
}: {
  onPrint: () => void
  onFax: () => void
  onDismiss: () => void
  isPrinting: boolean
}): JSX.Element {
  return (
    <>
      <DropdownMenuItem
        onClick={onDismiss}
        onSelect={onPrint}
        disabled={isPrinting}
        loading={isPrinting}
      >
        <IconPrinter />
        Print
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onDismiss} onSelect={onFax}>
        <IconSend />
        Fax
      </DropdownMenuItem>
    </>
  )
}
